// eslint-disable-next-line
export const getLocale = state => state.locale;
